import Vue from 'vue'
export default {
  name: 'column',
  props: {
    column: {
      type: Object,
      required: true
    },
    renderColumn: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      text: 'Click me',
    };
  },
  methods: {
    handleClick() {
      console.log('clicked');
    },
  },
  render(h) {
    return this.renderColumn(h, {'column':this.column})
  },
};


// WEBPACK FOOTER //
// ./src/plugins/mtui/table/Column.js